const initialState = {
  subscriptionManagerDeleteData: {
    emableModel: false,
    message: "",
    enableCancleButton: true,
    enableOkButton: true,
    headerMsg: "",
  },
  searchOptions: {},
  searchResults: [],
  allData: [],
  currentApiData: "",
  searchResults: {},
  selectedSubscriptionManager: {},
  subscriptionEstimatedCost: {},
  totalItems: 0,
  totalPages: 0,
  currentPage: 1,
  tableLoading: false,
  sidebarLoading: false,
  subscriptionManagerLoading: false,
  showApiModel: false,
};

const SubscriptionManagerReducer = (state = initialState, action) => {
  const { type, payload, data, id } = action;

  switch (type) {
    case "SET_SEARCH_OPTIONS":
      return {
        ...state,
        searchOptions: action.data,
      };
    case "SET_SEARCH_RESULTS_SUBSCRIPTION_MANAGE":
      return {
        ...state,
        searchResults: data.content,
        totalItems: data.totalItems,
        totalPages: data.totalPages,
        currentPage: data.page,
      };
    case "SET_SUBSCRIPTION_MANAGER":
      return {
        ...state,
        // allData: Array.isArray(data.data.content) ? data.data.content : [],
        allData: Array.isArray(data) ? data : [],
      };

    case "ADD_SUBSCRIPTION_MANAGER":
      return {
        ...state,
        currentApiData: payload,
        // allData: [...state.allData, payload],
        // total: state.total + 1,
      };

    case "SET_SUBSCRIPTION_MANAGER_BY_ID":
      return {
        ...state,
        selectedSubscriptionManager: data,
      };

      case "SET_SUBSCRIPTION_ESTIMATED_COST":
      return {
        ...state,   
        subscriptionEstimatedCost: data,
      };

    case "DELETE_SUBSCRIPTION_MANAGER":
      return {
        ...state,
        allData: state.allData.filter((item) => item.id !== id),
        searchResults: state.searchResults.filter((item) => item.id !== id),
        total: state.total - 1,
      };
    case "OPEN_SUBSCRIPTION_MANAGER_DELETE":
      return {
        ...state,
        subscriptionManagerDeleteData: action.value,
      };
    case "SET_TABLE_LOADING":
      return {
        ...state,
        tableLoading: payload,
      };

    case "OPEN_SUBSCRIPTION_MANAGER_API":
      return {
        ...state,
        showApiModel: action.value,
      };

    case "SET_MODAL_LOADING":
      return {
        ...state,
        subscriptionManagerLoading: payload,
      };
    case "SET_SIDEBAR_LOADING":
      return {
        ...state,
        sidebarLoading: payload,
      };
    case "FILTER_API_DATA":
      let value = action.value;
      let filteredData = [];
      if (value.length) {
        filteredData = state.allData.filter((item) => {
          let startsWithCondition =
            item.name.toLowerCase().startsWith(value.toLowerCase()) ||
            item.organisationName.toLowerCase().startsWith(value.toLowerCase());

          let includesCondition =
            item.name.toLowerCase().includes(value.toLowerCase()) ||
            item.organisationName.toLowerCase().includes(value.toLowerCase());

          if (startsWithCondition) {
            return startsWithCondition;
          } else if (!startsWithCondition && includesCondition) {
            return includesCondition;
          } else return null;
        });

        return {
          ...state,
          filteredData,
        };
      } else {
        filteredData = state.data;
        return { ...state, filteredData };
      }

    default:
      return state;
  }
};

export default SubscriptionManagerReducer;
